import { Theme, ThemeOptions } from '@mui/material';
import { BoxShadows } from './boxShadows';

export const listStyles = (theme: Theme): ThemeOptions => ({
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
        },
      },
    },

    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          ':focus': {
            boxShadow: BoxShadows.btnFocus,
          },
        },
      },
    },

    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '3.5rem',
        },
      },
    },
  },
});
